<template>
  <div>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="12">
        <label><strong>Configure aqui quais e-mails deseja receber:</strong></label>
      </SGPColComponent>
    </SGPRowComponent>
    <SGPRowComponent no-gutters>
      <SGPColComponent cols="4">
        <SGPFormToggleComponent
              name="aceita_receber_email"
              titulo="Alteração de Status (Solicitante)"
              v-model="formulario.aceita_receber_email"
              @input="atualizaAlarme"
            />
      </SGPColComponent>
    </SGPRowComponent>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "ConfiguracaoUsuarioPage",
    
    props: {
      usuario: {
        type: Object,
        required: false
      },
      configuracao: {
        type: Object,
        required: false
      },
      aceita_receber_email: {
        type: Boolean,
        required: false
      }
    },

    computed: {
      ...mapGetters('usuarios', ['configuracao', 'listaDeConfiguracoesUsuarios']),
      ...mapGetters('login', ['usuarioLogado']),
    },

    created() {
      if(this.configuracao[0]){
        this.formulario = this.configuracao[0]
      }
    },

    data () {
      return {
        formulario: this.$props.usuario || {
          aceita_receber_email: ''
        }
      }
    },

    methods: {
      ...mapActions('usuarios', [
        'atualizaNotificacaoAlarme',
        'getUsuario',
        'getConfiguracaoUsuario'
      ]),

      atualizaAlarme(){
        this.atualizaNotificacaoAlarme(this.formulario);
      }
    }
}

</script>